import React, { MutableRefObject, useEffect, useMemo, useState } from 'react';
import { IListing } from "../models/listing.model";
import ListingDetailsContainer from './listing-details-container';
import { useParams } from "react-router-dom";
import { ICoord } from '../models/coord.model';
import { IListings } from '../models/listings.model';
import { IBranding } from '../models/branding.model';
import { LISTING_DETAILS_API_URL } from '../util/listing-search.constants';

export interface IListingDetailsIndex {
  closeUrl: MutableRefObject<string>;
  savedListings: IListings;
  branding: IBranding;
  setMapCenterCoord(value: ICoord, forceUpdate: boolean, updateIfInitialized: boolean): void;
  addSavedListing(value: IListing | null): void;
  removeSavedListing(value: IListing | null): void;
  isSavedListing(id: string): boolean;
}

export const ListingDetailsIndex: React.FC<IListingDetailsIndex> = (props: IListingDetailsIndex) => {

  const [mlsData, setMlsData] = useState<IListing | null | undefined>(undefined);
  const params = useParams();
  const slug = params.slug ?? "-";
  const parts = slug.split("-");
  const mlsId = parts[0].trim();
  const hasMlsId = mlsId !== "";
  const mls = 'wpl';

  const listingApiUrl = LISTING_DETAILS_API_URL + "?mls=" + mls + "&mlsid=" + mlsId;

  const isSavedListing = useMemo(() => {
    return (mlsData === null || mlsData === undefined)
      ? false
      : props.isSavedListing(mlsData.id)
  }, [mlsData, props]);

  useEffect(() => {
    if (hasMlsId && mlsData !== null) {
      if (mlsData === undefined || (mlsData.mlsId !== "" && mlsData.mlsId !== params.id)) {
        fetch(listingApiUrl)
          .then(response => {
            let json = response.json();
            if (response.status >= 200 && response.status < 300) {
              return json;
            }
            return json.then(err => {
              throw new Error(err.status + ": " + err.title);
            });
          })
          .then(listing => {
            setMlsData(listing);
            listing.coords !== undefined && listing.coords !== null &&
              props.setMapCenterCoord(listing.coords, true, false);

            // if we do not have a closeUrl or the closeUrl is to a default search map with no options, we add the LngLat from
            // the listing to make the next (closed) page url sensible
            (props.closeUrl.current === '' || props.closeUrl.current === '/search/') &&
              listing.coords !== undefined && listing.coords.lat !== undefined &&
              (props.closeUrl.current = '/search/?x=' + encodeURIComponent(JSON.stringify([listing.coords.lat, listing.coords.lng])));
          })
          .catch(err => {
            setMlsData(null);
            props.closeUrl.current === '' &&
              (props.closeUrl.current = '/search/');
          });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasMlsId, listingApiUrl, params.id, props]);

  return (
    <>
      {(mlsData === null || mlsData) &&
        <ListingDetailsContainer
          closeUrl={props.closeUrl}
          isSavedListing={isSavedListing}
          branding={props.branding}
          listing={mlsData}
          addSavedListing={props.addSavedListing}
          removeSavedListing={props.removeSavedListing}
        />
      }
    </>
  );
}

export default ListingDetailsIndex;
